import api from '../utils/api';

export const FETCH_CHILDREN_SUCCESS = 'FETCH_CHILDREN_SUCCESS';
export const ADD_CHILD_SUCCESS = 'ADD_CHILD_SUCCESS';
export const UPDATE_CHILD_SUCCESS = 'UPDATE_CHILD_SUCCESS';
export const DELETE_CHILD_SUCCESS = 'DELETE_CHILD_SUCCESS';

const extractChildPayload = (data) => {
  if (!data) return null;
  if (typeof data === 'object' && data !== null && 'child' in data) {
    return data.child;
  }
  return data;
};

export const fetchChildrenByGroup = (groupId) => async (dispatch) => {
  try {
    const res = await api.get(`/children/group/${groupId}`);
    dispatch({
      type: FETCH_CHILDREN_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching children:', error);
    // Handle error as needed
  }
};

export const addChild = (childData) => async (dispatch) => {
  try {
    const res = await api.post('/children', childData);
    dispatch({
      type: ADD_CHILD_SUCCESS,
      payload: extractChildPayload(res.data),
    });
  } catch (error) {
    console.error('Error adding child:', error);
    // Handle error as needed
  }
};

export const updateChild = (child_id, childData) => async (dispatch) => {
  try {
    const res = await api.put(`/children/${child_id}`, childData);
    dispatch({
      type: UPDATE_CHILD_SUCCESS,
      payload: extractChildPayload(res.data),
    });
  } catch (error) {
    console.error('Error updating child:', error);
    // Handle error as needed
  }
};

export const deleteChild = (child_id) => async (dispatch) => {
  try {
    await api.delete(`/children/${child_id}`);
    dispatch({
      type: DELETE_CHILD_SUCCESS,
      payload: child_id,
    });
  } catch (error) {
    console.error('Error deleting child:', error);
    // Handle error as needed
  }
};
